import React, { useEffect, useState } from "react";
import DefaultLayout from "../../Defaultlayout/DefaultLayout";
import {
  Button,
  Card,
  Col,
  Row,
  Table,
  Modal,
  Input,
  Grid,
  Typography,
} from "antd";
import { _delete, _get } from "../services/service_api";
import {
  API_BASE_URL,
  DELETE_HOSPITAL,
  directToken,
  LIST_OF_HOSPITAL,
} from "../services/end_points";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import AddHospital from "./AddHospital";
import EditHospital from "./EditHospital";
import { useRoleData } from "../Data/Roledata";

const { useBreakpoint } = Grid;

const HospitalList = ({ handleRole }) => {
  const { column, rows } = useRoleData({ handleRole });
  const isAdmin = rows.some((row) => row.userType === "Admin");
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 8;
  const [hospital, setHospital] = useState([]);
  const [alert, setAlert] = useState(null);
  const [filteredHospital, setFilteredHospital] = useState([]);
  const userId = localStorage.getItem("userid");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  useEffect(() => {
    fetchData();
  }, []);

  const showModal = () => setIsModalVisible(true);
  const fetchData = async () => {
    try {
      const response = await _get(
        `${API_BASE_URL}${LIST_OF_HOSPITAL}/${userId}`,
        directToken
      );
      if (response.data && response.data.list) {
        setHospital(response.data.list);
        setFilteredHospital(response.data.list);
      } else {
        // console.error("Response data is not as expected:", response.data);
      }
    } catch (error) {
      console.error("Error fetching hospitals:", error.message);
    }
  };

  const handleDelete = async (hospitalId) => {
    try {
      const response = await _delete(
        `${API_BASE_URL}${DELETE_HOSPITAL}${hospitalId}`
      );
      console.log("Hospital deleted successfully:", response);
      setAlert({
        type: "success",
        message: response.data.message || "Hospital Deleted!",
      });
      fetchData();
    } catch (error) {
      console.error("Error deleting hospital:", error);
    }
  };

  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    const filtered = hospital.filter((hospitalItem) =>
      hospitalItem.hospitalName.toLowerCase().includes(value)
    );
    setFilteredHospital(filtered);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const paginatedData = filteredHospital.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const handleEditforopup = (record) => {
    setSelectedRecord(record);
    setIsModalVisible(true);
    setIsEditing(true);
  };

  const dynamicData = paginatedData.map((dataItem, index) => ({
    key: dataItem.id,
    serialNumber: (
      <Typography
        display="block"
        variant="button"
        fontWeight="medium"
        fontSize="1.2rem"
      >
        {(currentPage - 1) * pageSize + index + 1}
      </Typography>
    ),
    HospitalName: (
      <Typography
        display="block"
        variant="button"
        fontWeight="medium"
        fontSize="1.2rem"
      >
        {dataItem.hospitalName}
      </Typography>
    ),
    Action: (
      <>
        <Button
          size="small"
          style={{
            fontSize: "12px",

            border: "1px solid #0899f9",
            color: "#0899f9",
          }}
          onClick={() => handleEditforopup(dataItem)}
        >
          <EditOutlined />
        </Button>
        {isAdmin && (
          <Button
            size="small"
            style={{
              marginLeft: "5px",
              fontSize: "12px",
              border: "1px solid #941717",
              color: "#941717",
            }}
            onClick={() => handleDelete(dataItem.id)}
          >
            <DeleteOutlined />
          </Button>
        )}
      </>
    ),
  }));
  const closeModal = () => {
    setIsModalVisible(false);
    // setIsEditing(false);
  };
  // const columns = [
  //   {
  //     title: "Serial Number",
  //     dataIndex: "serialNumber",
  //     key: "serialNumber",
  //   },
  //   {
  //     title: "Hospital Name",
  //     dataIndex: "HospitalName",
  //     key: "HospitalName",
  //   },
  //   {
  //     title: "Action",
  //     dataIndex: "Action",
  //     key: "Action",
  //   },
  // ];
  const columns = [
    {
      title: "Serial Number",
      dataIndex: "serialNumber",
      key: "serialNumber",
    },
    {
      title: "Hospital Name",
      dataIndex: "HospitalName",
      key: "HospitalName",
      render: (text) => (
        <div
          style={{
            maxWidth: "200px", // Adjust as needed
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
          title={text} // Displays full text on hover
        >
          {text}
        </div>
      ),
    },
    {
      title: "Action",
      dataIndex: "Action",
      key: "Action",
    },
  ];

  const screens = useBreakpoint();
  let modalWidth;
  if (screens.xl) {
    modalWidth = 350;
  } else if (screens.lg) {
    modalWidth = 250;
  } else if (screens.md) {
    modalWidth = 200;
  } else if (screens.sm) {
    modalWidth = 400;
  } else {
    modalWidth = 300;
  }
  const updateUserList = (newUser) => {
    console.log(newUser);
    setHospital((prevUser) => {
      const index = prevUser.findIndex((user) => user.id === newUser.id);
      if (index === -1) {
        // Add new user
        return [...prevUser, newUser];
      } else {
        // Update existing user
        const updatedUsers = [...prevUser];
        updatedUsers[index] = newUser;
        return updatedUsers;
      }
    });
    setFilteredHospital((prevFilteredUser) => {
      const index = prevFilteredUser.findIndex(
        (user) => user.id === newUser.id
      );
      if (index === -1) {
        // Add new user
        return [...prevFilteredUser, newUser];
      } else {
        // Update existing user
        const updatedUsers = [...prevFilteredUser];
        updatedUsers[index] = newUser;
        return updatedUsers;
      }
    });
    fetchData();
  };

  return (
    <DefaultLayout>
      <Card style={{ width: "100%", minHeight: "600px", height: "100%" }}>
        <Row align="middle">
          <Col xs={24} sm={24} md={8} lg={8} xl={8}>
            <h2>Hospital List</h2>
          </Col>
          <Col xs={24} sm={24} md={10} lg={10} xl={10}>
            <Input
              style={{ width: "100%", height: "45px" }}
              placeholder="Search Hospitals"
              onChange={handleSearch}
            />
          </Col>
          <Col
            xs={24}
            sm={24}
            md={6}
            lg={6}
            xl={6}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              style={{
                // backgroundColor: "#feccdc",
                // color: "black",
                // borderRadius: "10px",
                // width: "100px",
                backgroundColor: "#6499f1",
                color: "white",
                fontSize: "14px",
                fontWeight: "600",
                borderRadius: "10px",
                width: "100%",
                height: "48px",
                maxWidth: "200px",
              }}
              onClick={showModal}
            >
              Create Hospital
            </Button>
          </Col>
        </Row>

        <Row>
          <Col xs={24} sm={24} md={22} lg={20} xl={24}>
            <div style={{ width: "100%", overflowX: "auto" }}>
              <Table
                columns={columns}
                dataSource={dynamicData}
                rowKey="key"
                pagination={{
                  current: currentPage,
                  pageSize: pageSize,
                  total: filteredHospital.length,
                  onChange: handlePageChange,
                  showSizeChanger: false,
                }}
                scroll={{ x: true }}
              />
            </div>
          </Col>
        </Row>
        <Modal
          title={isEditing ? "Edit Hospital" : "Create Hospital"}
          visible={isModalVisible}
          onCancel={closeModal}
          footer={null}
          width={modalWidth}
        >
          {isEditing ? (
            <EditHospital data={selectedRecord} />
          ) : (
            <AddHospital updateUserList={updateUserList} />
          )}
        </Modal>
      </Card>
    </DefaultLayout>
  );
};
export default HospitalList;
